module.exports = __webpack_public_path__ + "img/lc_yqgz.e4920992.svg";